import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
export var AddedToBagContainer;
(function(AddedToBagContainer) {
    AddedToBagContainer["BRAND_CART"] = "BRAND_CART";
    AddedToBagContainer["ADDED_TO_CART"] = "ADDED_TO_CART";
})(AddedToBagContainer || (AddedToBagContainer = {}));
var DEFAULT_IGNORED_CONTAINERS = {
    BRAND_CART: false,
    ADDED_TO_CART: false
};
var _createContextStore = createContextStore({
    shouldIgnore: false,
    ignoredContainers: DEFAULT_IGNORED_CONTAINERS,
    shouldRefreshCartPage: false
}, {
    name: "AddedToBagContextStore"
}), useAddedToBagContextStore = _createContextStore.useStore, AddedToBagContextStoreProvider = _createContextStore.Provider;
export { useAddedToBagContextStore, AddedToBagContextStoreProvider };
